import { render } from "./ApplicationManage.vue?vue&type=template&id=c705c63a&scoped=true&ts=true"
import script from "./ApplicationManage.vue?vue&type=script&lang=ts"
export * from "./ApplicationManage.vue?vue&type=script&lang=ts"

import "./ApplicationManage.vue?vue&type=style&index=0&id=c705c63a&scoped=true&lang=css"

import exportComponent from "D:\\Work\\IMMS\\IMMSV3\\App\\IMMS.MasterClient\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c705c63a"],['__file',"src/views/applications/ApplicationManage.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "c705c63a"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('c705c63a', __exports__)) {
    console.log('reload')
    api.reload('c705c63a', __exports__)
  }
  
  module.hot.accept("./ApplicationManage.vue?vue&type=template&id=c705c63a&scoped=true&ts=true", () => {
    console.log('re-render')
    api.rerender('c705c63a', render)
  })

}


export default __exports__